import { Map } from 'lucide-react'

export function StoreMapsPage() {
    return (
        <div className="flex-1 flex items-center justify-center p-6 md:p-10">
            <div className="text-center max-w-md">
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
                    <Map className="h-8 w-8 text-primary" />
                </div>
                <h1 className="app-page-title mb-3">Store Maps</h1>
                <p className="app-page-subtitle font-medium mb-2">Coming Soon</p>
                <p className="app-card-description">
                    Store coverage maps and location intelligence. Visualize your distribution network
                    and identify expansion opportunities.
                </p>
            </div>
        </div>
    )
}
